import clsx from 'clsx';
import ErrorsButton from '@/components/Editor/modals/Data/Editor/ErrorsButton';
import displayModalStyles from '@/components/ModalHoc/stylesDisplay.module.scss';
import commonModalStyles from '@/components/ModalHoc/stylesQuestion.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const EditorModalsFooter = _ref => {
  let {
    actions,
    className,
    showCloseButton = true,
    containerWidth = 0,
    errors = [],
    onErrorsClick = () => undefined
  } = _ref;
  return /*#__PURE__*/_jsxs("footer", {
    className: clsx(displayModalStyles.footer, className),
    children: [showCloseButton ? /*#__PURE__*/_jsx("span", {
      className: commonModalStyles.linkLikeButton,
      "data-modal": "trigger-close",
      children: "Close"
    }) : null, (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && containerWidth <= 860 && /*#__PURE__*/_jsx(ErrorsButton, {
      counter: errors.length,
      onClick: onErrorsClick
    }), actions]
  });
};

export default EditorModalsFooter;